// document.addEventListener('DOMContentLoaded', () => {
//     const variantImages = {
//         'heart-shape': {
//         inactive: 'https://cdn.shopify.com/s/files/1/0958/5695/1578/files/heart-shape-inactive.png?v=1787570585',
//         active: 'https://cdn.shopify.com/s/files/1/0958/5695/1578/files/heart-shape-active.png?v=1787570585'
//         },
//         'bone-shape': {
//         inactive: 'https://cdn.shopify.com/s/files/1/0958/5695/1578/files/bone-shape-inactive.png?v=1787570585',
//         active: 'https://cdn.shopify.com/s/files/1/0958/5695/1578/files/bone-shape-active.png?v=1787570585'
//         }
//     };

//     function initVariantImageSelector() {
//         const fieldsets = document.querySelectorAll(
//         '.product-variant-picker-block'
//         );

//         fieldsets.forEach((fieldset) => {
//         const inputs = fieldset.querySelectorAll(
//             'input[data-single-option-selector]'
//         );

//         inputs.forEach((input) => {
//             const handle = input.dataset.handle;
//             const images = variantImages[handle];

//             if (!images) return;

//             const label = fieldset.querySelector(
//             `label[for="${CSS.escape(input.id)}"]`
//             );

//             if (!label) return;

//             // Prevent creating duplicate images
//             let image = label.querySelector('.custom-variant-image');

//             if (!image) {
//             image = document.createElement('img');
//             image.className = 'custom-variant-image';

//             // Hide the existing text visually but keep it in the DOM
//             const span = label.querySelector('span');
//             if (span) {
//                 span.classList.add('custom-variant-text');
//             }

//             label.appendChild(image);
//             }

//             // Set image based on current state
//             image.src = input.checked
//             ? images.active
//             : images.inactive;

//             image.alt = input.value;

//             // Mark selected state
//             label.classList.toggle('custom-variant-selected', input.checked);
//         });

//         // Listen for Shopify's existing variant change
//         inputs.forEach((input) => {
//             input.addEventListener('change', () => {
//             inputs.forEach((otherInput) => {
//                 const handle = otherInput.dataset.handle;
//                 const images = variantImages[handle];

//                 if (!images) return;

//                 const label = fieldset.querySelector(
//                 `label[for="${CSS.escape(otherInput.id)}"]`
//                 );

//                 const image = label?.querySelector('.custom-variant-image');

//                 if (!image) return;

//                 image.src = otherInput.checked
//                 ? images.active
//                 : images.inactive;

//                 label.classList.toggle(
//                 'custom-variant-selected',
//                 otherInput.checked
//                 );
//             });
//             });
//         });
//         });
//     }

//     initVariantImageSelector();
// });


document.addEventListener('DOMContentLoaded', () => {
  const variantSVGs = {
    'heart-shape': 'https://cdn.shopify.com/s/files/1/0958/5695/1578/files/heart-shape.svg?v=1787641024',
    'bone-shape': 'https://cdn.shopify.com/s/files/1/0958/5695/1578/files/bone-shape.svg?v=1787641023'
  };

  const initVariantSelectors = async () => {
    const fieldsets = document.querySelectorAll(
      '.product-variant-picker-block'
    );

    for (const fieldset of fieldsets) {
      const inputs = fieldset.querySelectorAll(
        'input[data-single-option-selector]'
      );

      if (!inputs.length) continue;

      // Create all SVG selectors
      for (const input of inputs) {
        const handle = input.dataset.handle;
        const svgUrl = variantSVGs[handle];

        if (!svgUrl) continue;

        const label = fieldset.querySelector(
          `label[for="${CSS.escape(input.id)}"]`
        );

        if (!label) continue;

        // Hide original variant text
        label.querySelector('span')?.classList.add('custom-variant-text');

        // Don't recreate if already initialized
        if (label.querySelector('.shape-selector-img')) continue;

        const wrapper = document.createElement('div');
        wrapper.className = 'shape-selector-img';

        try {
          const response = await fetch(svgUrl);

          if (!response.ok) {
            throw new Error(`Failed to load SVG: ${svgUrl}`);
          }

          wrapper.innerHTML = await response.text();

          label.appendChild(wrapper);

          updateState(input, wrapper);
        } catch (error) {
          console.error(error);
        }
      }

      // Listen for variant changes
      inputs.forEach((input) => {
        input.addEventListener('change', () => {
          inputs.forEach((currentInput) => {
            const label = fieldset.querySelector(
              `label[for="${CSS.escape(currentInput.id)}"]`
            );

            const wrapper = label?.querySelector('.shape-selector-img');

            if (!wrapper) return;

            updateState(currentInput, wrapper);
          });
        });
      });
    }
  };

  const updateState = (input, wrapper) => {
    wrapper.classList.toggle('is-active', input.checked);
    wrapper.classList.toggle('is-inactive', !input.checked);
  };

  initVariantSelectors();
});